module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startTest-wrap"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "setInfo-content"
  }, [_c('div', {
    staticClass: "myfrom"
  }, [_c('h3', [_vm._v("提示:您是首次进行脑能力检测的用户,为了检测的结果更加准确,请您完善以下基本信息 !")]), _vm._v(" "), _c('el-form', {
    ref: "userInfomation",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.userInfomation,
      "rules": _vm.rules,
      "label-width": "90px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "value": _vm.userInfomation.userName
    },
    model: {
      value: (_vm.userInfomation.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userName", $$v)
      },
      expression: "userInfomation.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.userSex),
      callback: function($$v) {
        _vm.userSex = $$v
      },
      expression: "userSex"
    }
  }, _vm._l((_vm.userSexList), function(item, index, key) {
    return _c('el-radio-button', {
      key: key,
      attrs: {
        "label": key,
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号：",
      "prop": "userCard"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 18,
      "value": _vm.userInfomation.userCard
    },
    on: {
      "change": _vm.regCarNum
    },
    model: {
      value: (_vm.userInfomation.userCard),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userCard", $$v)
      },
      expression: "userInfomation.userCard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月：",
      "prop": "userBirthday"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择日期",
      "default-value": "1990",
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.dataFormt
    },
    model: {
      value: (_vm.userInfomation.userBirthday),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userBirthday", $$v)
      },
      expression: "userInfomation.userBirthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("温馨提示：身份证信息将帮助您可以对比查看多年检测报告"), _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/xian.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "行业",
      "prop": "userJobs"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.getclassification(_vm.userInfomation.userJobs)
      }
    },
    model: {
      value: (_vm.userInfomation.userJobs),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userJobs", $$v)
      },
      expression: "userInfomation.userJobs"
    }
  }, _vm._l((_vm.loadUserProfessional), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类：",
      "prop": "classification"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.classification),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "classification", $$v)
      },
      expression: "userInfomation.classification"
    }
  }, _vm._l((_vm.loadclassificationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现居住地",
      "prop": "userLives"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userLives),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userLives", $$v)
      },
      expression: "userInfomation.userLives"
    }
  }, _vm._l((_vm.loadUserLiveList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教育程度",
      "prop": "userEducation"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userEducation),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userEducation", $$v)
      },
      expression: "userInfomation.userEducation"
    }
  }, _vm._l((_vm.loadUserEducationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "healthList-wrap",
    attrs: {
      "label": "健康状况"
    }
  }, [_c('div', {
    staticClass: "healthList",
    attrs: {
      "id": "content"
    }
  }, _vm._l((_vm.loadUserHealthList), function(item, index) {
    return _c('span', {
      attrs: {
        "data-num": index + 1
      },
      on: {
        "click": function($event) {
          _vm.check(index, $event.target)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('input', {
    staticClass: "isnone",
    attrs: {
      "type": "text",
      "id": "inp"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "button-content"
  }, [_c('el-button', {
    staticClass: "buttons",
    on: {
      "click": function($event) {
        _vm.saveInfo('userInfomation')
      }
    }
  }, [_vm._v("开始检测")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a225acc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/startTest.vue
// module id = 745
// module chunks = 1